import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class AuthorisationService {
    private baseApiUrl: string;

    constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }

    getMaintenanceQueue(pageIndex: number, pageSize: number, sortColumn: string, sortAscending: boolean): Observable<any> {
        let params = new HttpParams();
        params = params.append('pageIndex', pageIndex.toString());
        params = params.append('pageSize', pageSize.toString());
        params = params.append('sortColumn', sortColumn);
        params = params.append('sortAscending', sortAscending.toString());

        return this.httpClient.get(this.baseApiUrl + 'authorisationqueue/maintenance', { params: params }).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getTransactionQueue(pageIndex: number, pageSize: number, sortColumn: string, sortAscending: boolean): Observable<any> {
        let params = new HttpParams();
        params = params.append('pageIndex', pageIndex.toString());
        params = params.append('pageSize', pageSize.toString());
        params = params.append('sortColumn', sortColumn);
        params = params.append('sortAscending', sortAscending.toString());

        return this.httpClient.get(this.baseApiUrl + 'authorisationqueue/transaction', { params: params }).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getPendingItemsCount(): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + 'authorisationqueue/count').pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
}
